var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 7.8C3.5 7.05739 3.78446 6.3452 4.29081 5.8201C4.79716 5.295 5.48392 5 6.2 5H18.8C19.5161 5 20.2028 5.295 20.7092 5.8201C21.2155 6.3452 21.5 7.05739 21.5 7.8C21.5 8.31547 21.0821 8.73333 20.5667 8.73333H4.43333C3.91787 8.73333 3.5 8.31547 3.5 7.8ZM4.5 9.66667C3.94772 9.66667 3.5 10.1144 3.5 10.6667V16.2C3.5 16.9426 3.78446 17.6548 4.29081 18.1799C4.79716 18.705 5.48392 19 6.2 19H18.8C19.5161 19 20.2028 18.705 20.7092 18.1799C21.2155 17.6548 21.5 16.9426 21.5 16.2V10.6667C21.5 10.1144 21.0523 9.66667 20.5 9.66667H4.5ZM8 11.5333C7.7613 11.5333 7.53239 11.6317 7.3636 11.8067C7.19482 11.9817 7.1 12.2191 7.1 12.4667C7.1 12.7142 7.19482 12.9516 7.3636 13.1266C7.53239 13.3017 7.7613 13.4 8 13.4H12.5C12.7387 13.4 12.9676 13.3017 13.1364 13.1266C13.3052 12.9516 13.4 12.7142 13.4 12.4667C13.4 12.2191 13.3052 11.9817 13.1364 11.8067C12.9676 11.6317 12.7387 11.5333 12.5 11.5333H8Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon_card.c6a00b057da25bfa1728980574d06484.svg";
export { ForwardRef as ReactComponent };